// extracted by mini-css-extract-plugin
export default {"bottomNav":"bottomNav_bottomNav__XLMl7","navItem":"bottomNav_navItem__eTARB","navItemCurrent":"bottomNav_navItemCurrent__EBcQm"};